import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UIState, Notification } from '../../types';

const initialState: UIState = {
  loading: false,
  notification: null,
  modal: {
    open: false,
    type: null,
    data: null,
  },
  drawer: {
    open: false,
    type: null,
  },
  theme: 'light',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    showNotification: (state, action: PayloadAction<Partial<Notification>>) => {
      state.notification = {
        message: action.payload.message || '',
        type: action.payload.type || 'info',
        duration: action.payload.duration || 3000,
      };
    },
    hideNotification: (state) => {
      state.notification = null;
    },
    openModal: (state, action: PayloadAction<{ type: string; data?: any }>) => {
      state.modal = {
        open: true,
        type: action.payload.type,
        data: action.payload.data || null,
      };
    },
    closeModal: (state) => {
      state.modal = {
        open: false,
        type: null,
        data: null,
      };
    },
    toggleDrawer: (state, action: PayloadAction<{ open: boolean; type?: string }>) => {
      state.drawer = {
        open: action.payload.open,
        type: action.payload.type || null,
      };
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
  },
});

export const {
  setLoading,
  showNotification,
  hideNotification,
  openModal,
  closeModal,
  toggleDrawer,
  setTheme,
} = uiSlice.actions;

export default uiSlice.reducer;